import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Toast } from '@openng/optimus-ui/toast';

@Component({
  imports: [RouterOutlet, Toast],
  selector: 'app-root',
  styleUrl: './app.scss',
  templateUrl: './app.html',
})
export class App {}
